<template>
    <v-alert class="alert-banner" icon="custom:locked" density="compact" variant="text">
        <span class="alert-banner__locked">
            {{ toSentenceCase($t('general.alerts.locked')) }}
        </span>

        <span class="alert-banner__locked-msg">
            {{ toSentenceCase($t(reason)) }}
        </span>
    </v-alert>
</template>

<script setup>
defineProps({
    reason: {
        type: String,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_mixins.scss';
@import '@style/base/_variables.scss';

.v-alert--density-compact {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.alert-banner {
    padding-left: 0;
    line-height: 2.5rem;
    min-height: 4rem;

    :deep(.v-alert__prepend) {
        margin-inline-end: 0.5rem;
        min-height: 3.5rem;
    }

    &__locked {
        font-size: 1.2rem;
        font-weight: 700;
        color: $alert-banner;
        margin-right: 0.25rem;
    }

    &__locked-msg {
        font-size: 1.2rem;
        color: $alert-banner;
    }

    :deep(svg) {
        height: 2.6rem;
        width: 2.6rem;
        path {
            fill: $alert-banner;
        }
    }
}
</style>
